import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import BrandclubPhoneInput, { BCPhoneInputVariant } from '../BrandclubPhoneInput/index.js';
import { PopupDrawer } from '../PopupDrawer/PopupDrawer.js';
import React, { useState, useEffect } from 'react';
import { RewardTable } from './RewardTable.js';
import { ArrowLink } from './ArrowLink.js';
import { BrandclubVideo } from '../BrandclubVideo.js';
import { SharePage } from './SharePage.js';
import { trackRetailerProductPageEvent, buildTrackingParams } from '../../../utils/analytics.js';
import { getAssetNameFromUrl } from '../../../utils/assetUtils.js';
import { ProductPageDialogSuccess } from './ProductPageDialogSuccess.js';
import { ProductPageDialogContent } from './ProductPageDialogContent.js';
import { AnalyticsTrackingEvent } from '../../../analytics/events.js';

var ProductPageDialogMain = function (_a) {
    var _b = _a.popupDrawerProps, open = _b.open, onClose = _b.onClose, showIcon = _a.showIcon, imageUrl = _a.imageUrl, _c = _a.imageSize, imageSize = _c === void 0 ? 51 : _c, title = _a.title, secondTitle = _a.secondTitle, subtitle = _a.subtitle, phoneInput = _a.phoneInput, redirect = _a.redirect, sharePage = _a.sharePage, sharePageUrl = _a.sharePageUrl, onShareLinkCopied = _a.onShareLinkCopied, rewardTableRows = _a.rewardTableRows, video = _a.video, Link = _a.Link, mainEntity = _a.mainEntity, trackingParams = _a.trackingParams, retailerPDPNavigationEventParams = _a.retailerPDPNavigationEventParams, trackRetailerPDPNavigation = _a.trackRetailerPDPNavigation, analyticsTrack = _a.analyticsTrack, handleSendText = _a.handleSendText, userProfile = _a.userProfile;
    var _d = useState(0), step = _d[0], setStep = _d[1];
    var onTextSent = function () { return setStep(1); };
    var handleClose = function () {
        if (step !== 0) {
            setStep(0);
        }
        onClose();
    };
    var trackVideoInteraction = function (eventName, additionalEventProps) {
        if (additionalEventProps === void 0) { additionalEventProps = {}; }
        var videoId = getAssetNameFromUrl((video === null || video === void 0 ? void 0 : video.videoUrl) || '');
        if (videoId && (video === null || video === void 0 ? void 0 : video.videoUrl) && trackingParams && mainEntity && analyticsTrack) {
            var eventProps = __assign(__assign(__assign({}, buildTrackingParams({ trackingParams: trackingParams, mainEntity: mainEntity })), { videoId: videoId, video: video.videoUrl, videoTitle: title }), additionalEventProps);
            analyticsTrack(eventName, eventProps);
        }
    };
    var handleVideoPlay = function () {
        trackVideoInteraction(AnalyticsTrackingEvent.LANDING_PAGE_VIDEO_PLAY_STARTED);
    };
    var handleVideoPause = function (_a) {
        var currentTime = _a.currentTime;
        trackVideoInteraction(AnalyticsTrackingEvent.LANDING_PAGE_VIDEO_PLAY_PAUSED, {
            videoPlayDuration: parseFloat(currentTime.toFixed(2)),
        });
    };
    var handleVideoEnd = function (_a) {
        var duration = _a.duration;
        trackVideoInteraction(AnalyticsTrackingEvent.LANDING_PAGE_VIDEO_PLAY_ENDED, {
            videoPlayDuration: parseFloat(duration.toFixed(2)),
        });
    };
    var handleTrackRetailerPDPNavigation = function () {
        if (retailerPDPNavigationEventParams && trackingParams && !!analyticsTrack) {
            var params = __assign(__assign({}, trackingParams), retailerPDPNavigationEventParams);
            trackRetailerProductPageEvent({
                trackingEventAction: 'navigateToRetailerProductPage',
                trackingParams: params,
                analyticsTrack: analyticsTrack,
            });
        }
    };
    useEffect(function () {
        var autoRedirectTimeout = undefined;
        if (!!(phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.autoRedirectOnSuccess) && (phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionUrl) && step === 1) {
            autoRedirectTimeout = setTimeout(function () {
                window.open(phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionUrl);
            }, 2000);
        }
        return function () {
            if (autoRedirectTimeout) {
                clearTimeout(autoRedirectTimeout);
            }
        };
    }, [phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.autoRedirectOnSuccess, phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionUrl, step]);
    return (React.createElement(PopupDrawer, { open: open, onClose: handleClose }, step === 0 ? (React.createElement(ProductPageDialogContent, { title: title, secondTitle: secondTitle, subtitle: subtitle, showIcon: showIcon, imageUrl: imageUrl, imageSize: imageSize, sx: {
            paddingBottom: "".concat(sharePage && video ? '30' : '48', "px"),
        } },
        phoneInput && handleSendText && (React.createElement("div", { className: "phone-input-container" },
            React.createElement(BrandclubPhoneInput, { userProfile: userProfile, hasHeader: false, buttonText: 'Get App', variant: BCPhoneInputVariant.SM, onTextSent: onTextSent, handleSendText: handleSendText }))),
        redirect && (React.createElement(ArrowLink, __assign({}, {
            text: redirect.text,
            url: redirect.url,
            onTextClick: function () {
                if (trackRetailerPDPNavigation) {
                    handleTrackRetailerPDPNavigation();
                }
                window.open(redirect.url, '_blank');
            },
        }))),
        sharePage && (React.createElement("div", { className: "share-container" },
            React.createElement(SharePage, { url: sharePageUrl || window.location.href, onShareLinkCopied: onShareLinkCopied }))),
        rewardTableRows && React.createElement(RewardTable, { rows: rewardTableRows, containerStyle: { marginTop: 10 } }),
        video && (React.createElement("div", { className: "video-container", style: { margin: "".concat(sharePage && video ? '0' : '12', "px auto 0") } },
            React.createElement(BrandclubVideo, { videoUrl: video.videoUrl, posterUrl: video.coverImageUrl, canPlay: true, onPlay: handleVideoPlay, onPause: handleVideoPause, onEnd: handleVideoEnd }))))) : (React.createElement(ProductPageDialogSuccess, { handleClose: handleClose, closeDialogText: phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.closeDialogText, redirectionText: phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionText, redirectionUrl: Link ? phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionUrl : undefined }))));
};
var ProductPageDialog = function (props) {
    var location = window.location;
    useEffect(function () {
        props.popupDrawerProps.open && props.popupDrawerProps.onClose();
        // close the dialog whenever the location changes
    }, [location]);
    return React.createElement(ProductPageDialogMain, __assign({}, props));
};

export { ProductPageDialog, ProductPageDialogMain };
//# sourceMappingURL=ProductPageDialog.js.map
